<div class="tiptap-editor">
  <div #editorContainer class="editor-content"></div>

  <!-- This div is targeted by BubbleMenu extension -->
  <div class="formatting-bubble-menu bubble-menu-container">
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="insertEmoji($event)"
      title="Emoji"
    >
      <ion-icon name="happy-outline"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleBold()"
      [class.is-active]="editor?.isActive('bold')"
      title="Bold"
    >
      <ion-icon name="custom-bold"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleItalic()"
      [class.is-active]="editor?.isActive('italic')"
      title="Italic"
    >
      <ion-icon name="custom-italic"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="setHeading(1)"
      [class.is-active]="editor?.isActive('heading', { level: 1 })"
      title="Heading 1"
    >
      <ion-icon name="custom-heading-1"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="setHeading(2)"
      [class.is-active]="editor?.isActive('heading', { level: 2 })"
      title="Heading 2"
    >
      <ion-icon name="custom-heading-2"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="setHeading(3)"
      [class.is-active]="editor?.isActive('heading', { level: 3 })"
      title="Heading 3"
    >
      <ion-icon name="custom-heading-3"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleBulletList()"
      [class.is-active]="editor?.isActive('bulletList')"
      title="Bulleted list"
    >
      <ion-icon name="custom-unordered-list"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleOrderedList()"
      [class.is-active]="editor?.isActive('orderedList')"
      title="Ordered list"
    >
      <ion-icon name="custom-ordered-list"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleBlockquote()"
      [class.is-active]="editor?.isActive('blockquote')"
      title="Block quote"
    >
      <ion-icon name="custom-blockquote"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleCode()"
      [class.is-active]="editor?.isActive('code')"
      title="Code"
    >
      <ion-icon name="custom-code-view"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleCodeBlock()"
      [class.is-active]="editor?.isActive('codeBlock')"
      title="Code block"
    >
      <ion-icon name="custom-code-block"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="addLink()"
      [class.is-active]="editor?.isActive('link')"
      title="Add link"
    >
      <ion-icon name="custom-link"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="clearFormatting()"
      title="Clear format"
    >
      <ion-icon name="custom-format-clear"></ion-icon>
    </ion-button>
  </div>

  <!-- Track Changes Controls -->
  <div class="track-changes-controls" *ngIf="trackChangesEnabled || diffMode">
    <!-- Individual diff action buttons will be inserted here dynamically -->
  </div>

  <!-- Track Changes Global Menu -->
  <div
    class="track-changes-menu bubble-menu-container"
    *ngIf="trackChangesEnabled && hasOutstandingDiffs()"
  >
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="acceptAllChanges()"
      title="Accept All"
    >
      <ion-icon name="checkmark-done-outline"></ion-icon> Accept All
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="rejectAllChanges()"
      title="Reject All"
    >
      <ion-icon name="close-circle-outline"></ion-icon> Reject All
    </ion-button>
  </div>

  <!-- Link Context Bubble Menu -->
  <div class="link-context-menu bubble-menu-container">
    <ion-button
      class="fake-button btn-small btn-formatting"
      (click)="openLink()"
      color="dark"
      fill="clear"
    >
      <span style="max-width: 320px; margin-right: 8px">{{
        getSelectedLink()
      }}</span>
      <ion-icon name="open-outline"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="editLink()"
      title="Edit Link"
    >
      <ion-icon name="pencil-outline"></ion-icon> Edit
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="unsetLink()"
      title="Remove Link"
    >
      <ion-icon name="trash-bin-outline"></ion-icon> Remove
    </ion-button>
  </div>
</div>
